import { render, staticRenderFns } from "./HistoryPacking.vue?vue&type=template&id=224505cf&scoped=true&"
import script from "./HistoryPacking.vue?vue&type=script&lang=js&"
export * from "./HistoryPacking.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPacking.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HistoryPacking.vue?vue&type=style&index=1&id=224505cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224505cf",
  null
  
)

export default component.exports